import React from "react";
import VideocamIcon from "@mui/icons-material/Videocam";
import { PageHeader } from "../../../shares/dashboard/DashboardWidgets";
import ClassCard from "./ClassCard";

/**
 * Course list.
 *
 * The old Header was a centred <h1> reading "نکته" (note) whose body was the
 * 80%-attendance rule - an advisory presented as the page title. That rule is
 * now the PageHeader `note`, and the page has an actual title.
 */
const Index = () => {
    return (
        <div className="flex flex-col gap-xl pb-4xl">
            <PageHeader
                title="جلسات"
                description="درس‌هایی که در گروه تو ارائه شده"
                icon={VideocamIcon}
                note="اگر کمتر از ۸۰ درصد ویدیوی هر جلسه را ببینی، آن جلسه غیبت در نظر گرفته می‌شود."
            />
            <ClassCard />
        </div>
    );
};

export default Index;
